require('../../modules/es.number.max-safe-integer');

module.exports = 0x1FFFFFFFFFFFFF;
